
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Mechanism_classification_of_humeral_intercondylar_fracture',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Mechanism_classification_of_humeral_intercondylar_fracture.vue